<app-option-bar [type]="'GOPHER'"></app-option-bar>
<div class="gopher-wrapper client-area">
  <div class="container-fluid">
    <div class="content-wrapper">
      <!-- Menu Section -->
      <div class="inner-nav">
        <app-left-menu [type]="'GOPHER'"></app-left-menu>
      </div>

      <div class="inner-content collapsed">
        <div class="row" style="margin: 1em -15px 0 0">
          <div class="col-md-1">Project</div>
          <div class="col-md-4">
            <ng-select
              class="custom-style"
              chosen
              [items]="myProjects"
              bindLabel="name"
              [clearable]="false"
              [(ngModel)]="config.project"
              (change)="getClientsById(config.project.id)"
              placeholder="Select Project"
              [searchable]="true"
            >
              <ng-template ng-option-tmp let-item="item">
                <div title="{{ item.name }}" class="text-truncate">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-2 relay-margin-top-10">
            <a *ngIf="config.project" (click)="showAdd = !showAdd"> <span class="fa fa-plus"></span> Add clients </a>
          </div>
        </div>
        <div class="common-section mt-3" [ngbCollapse]="!showAdd">
          <div class="common-heading">Add infrastructure details</div>
          <div class="common-box">
            <div class="row">
              <div class="col-3">
                <label>Server type</label>
                <ng-select class="custom-style" id="config-server" [(ngModel)]="config.server_type" [clearable]="false" [searchable]="false">
                  <ng-option value="Web server">Web server</ng-option>
                  <ng-option value="Application server">Application server</ng-option>
                  <ng-option value="Database server">Database server</ng-option>
                  <ng-option value="Other components">Other components</ng-option>
                </ng-select>
              </div>
              <div class="col">
                <label>Name</label>
                <input type="text" id="config-name-server" [(ngModel)]="config.name" class="form-control" />
              </div>
              <div class="col">
                <label>Host name</label>
                <input type="text" id="config-hostAddress" [(ngModel)]="config.hostAddress" class="form-control" />
              </div>
              <div class="col">
                <label>Username</label>
                <input type="text" id="config-username" [(ngModel)]="config.userName" class="form-control" />
              </div>
            </div>
            <div class="text-right mt-3">
              <button
                class="btn relay-btn save mr-1"
                [disabled]="!config.userName || !config.hostAddress"
                type="button"
                (click)="saveChaosClients(config)"
              >
                Save
              </button>
              <button class="btn relay-btn cancel" (click)="cancelAddClients()">Cancel</button>
            </div>
          </div>
        </div>
        <hr />
        <div class="table-responsive mt-2" *ngIf="config.project">
          <table class="table table-condensed gopher-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Server type</th>
                <th>Hostname</th>
                <th>Status</th>
                <th class="text-center">Select</th>
                <th class="text-center">Sync</th>
                <th></th>
              </tr>
            </thead>
            <tr *ngIf="clientsList && clientsList.length === 0">
              <td colspan="6">No clients found please add one.</td>
            </tr>
            <tr *ngFor="let val of clientsList">
              <td>{{ val.name }}</td>
              <td>{{ val.userName }}</td>
              <td>{{ val.server_type }}</td>
              <td>{{ val.hostAddress }}</td>
              <td>{{ val.status }}</td>
              <td class="text-center">
                <input type="radio" [value]="val.id" [(ngModel)]="config.clientId" *ngIf="val.status === 'AVAILABLE'" />
              </td>
              <td class="text-center">
                <img src="/assets/images/gopher/sync.png" (click)="syncClient(val.id)" />
              </td>
              <td>
                <img style="margin-top: -8px" src="/assets/images/icons/delete.png" width="18px" (click)="deleteClient(val.id, config.project)" />
              </td>
            </tr>
          </table>
        </div>
        <div class="text-right" *ngIf="config.project">
          <button
            class="btn btn-primary btn-sm"
            [disabled]="!config.clientId"
            [routerLink]="['../attack/new']"
            [queryParams]="{ project: config.project.id, client: config.clientId }"
          >
            Initiate Attack
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
